var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "contactum_entries" }, [
      _c("div", { staticClass: "contactum_entries_head" }, [
        _c("h1", { staticClass: "contactum_section_title" }, [
          _vm._v(" All Entries ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "entries_head_content" }, [
          _c(
            "div",
            { staticClass: "contactum_btn_group" },
            [
              _c(
                "div",
                {},
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "el-button--soft-2",
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toggleChart()
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.chart_status ? "Hide Chart" : "Show Chart"
                          ) +
                          " "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("DateFilter", {
                attrs: { filter_date_range: _vm.filter_date_range },
                on: {
                  "update:filter_date_range": function($event) {
                    _vm.filter_date_range = $event
                  },
                  "date-filter-changed": _vm.onDateFilterChanged
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.chart_status
        ? _c(
            "div",
            { staticClass: "entry_chart" },
            [
              _c("Chartview", {
                attrs: {
                  form_id: _vm.selectedFormId,
                  labels: _vm.labels,
                  datasets: _vm.datasets,
                  entry_status: _vm.entry_status
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "contactum-entries-content" }, [
        _c(
          "div",
          { staticClass: "ctm-table-card" },
          [
            _c(
              "div",
              { staticClass: "ctm-table-toolbar" },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "ctm-form-select",
                    attrs: {
                      clearable: "",
                      filterable: "",
                      placeholder: "All Forms"
                    },
                    on: { change: _vm.onchangeForm },
                    model: {
                      value: _vm.selectedFormId,
                      callback: function($$v) {
                        _vm.selectedFormId = $$v
                      },
                      expression: "selectedFormId"
                    }
                  },
                  _vm._l(_vm.forms, function(item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id }
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c("el-input", {
                  staticClass: "ctm-search-input",
                  attrs: {
                    clearable: "",
                    placeholder: "Search entries…",
                    "prefix-icon": "el-icon-search"
                  },
                  nativeOn: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.fetchEntries()
                    }
                  },
                  model: {
                    value: _vm.search,
                    callback: function($$v) {
                      _vm.search = $$v
                    },
                    expression: "search"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("EntriesTable", {
              attrs: {
                "paginated-data": _vm.paginatedData,
                loading: _vm.loading
              },
              on: { "entry-deleted": _vm.onEntryDeleted }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ctm-table-footer" },
              [
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    "current-page": _vm.paginate.current_page,
                    "page-sizes": [5, 10, 20, 50, 100],
                    "page-size": parseInt(_vm.paginate.per_page),
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.paginate.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.goToPage,
                    "update:currentPage": function($event) {
                      return _vm.$set(_vm.paginate, "current_page", $event)
                    },
                    "update:current-page": function($event) {
                      return _vm.$set(_vm.paginate, "current_page", $event)
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }